import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BadgeMap, BadgesEnum } from '@warema/shared/models';
@Component({
    selector: 'warema-business-card-badges',
    imports: [TranslatePipe],
    templateUrl: './business-card-badges.component.html',
    styleUrls: ['./business-card-badges.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessCardBadgesComponent {
    public readonly badges = input<Array<BadgesEnum>>([]);

    public readonly badgeMap = BadgeMap;
}
